import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CardHeaderTitleSubtitleComponent } from '../../ui/card-header-title-subtitle/card-header-title-subtitle.component';
import { ModalData } from '../../type/modal';
import { DataLayerService } from '../../../../core/services/data-layer.service';
import { normalizeScreenName } from '../../utils/utils';

@Component({
  selector: 'app-generic-modal',
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    CardHeaderTitleSubtitleComponent,
  ],
  providers: [],
  templateUrl: './generic-modal.component.html',
  styleUrl: './generic-modal.component.scss',
})
export class GenericModalComponent {
  @Input() modalData!: ModalData;
  screenName = 'generic_modal';

  constructor(private _modalController: ModalController,
    private readonly _dataLayerService: DataLayerService,
    private readonly _translateService: TranslateService
  ) {}

  dismiss() {
    this._dataLayerService.pushEventClickButton(this.screenName, 'dismiss', 'Close');
    this.modalData.dismissButton?.action();
    this._modalController.dismiss();
  }

  ngOnInit(): void {
    if (this.modalData.title) {
      const raw = this._translateService.instant(this.modalData.title);
      this.screenName = `modal_${normalizeScreenName(raw)}`;
    }

    this._dataLayerService.pushEventModalView(this.screenName);
  }

  _btnCancel(): void {
    this._dataLayerService.pushEventClickButton(this.screenName, 'cancel', this.modalData.leftButton?.label ?? 'generic_modal.cancel');
    this.modalData.leftButton?.action();
    this._modalController.dismiss();
  }

  _btnCont(): void {
    this._dataLayerService.pushEventClickButton(this.screenName, 'continue', this.modalData.rigthButton?.label ?? 'generic_modal.continue');
    this.modalData.rigthButton?.action();
    this._modalController.dismiss();
  }

}
